import React from 'react'
import styled from 'styled-components'
import { mediaQueries } from '@blazar-plugins/device'

const dotClassName = 'carousel-dot'

const DotsList = styled.ul`
  display: flex;
  justify-content: center;
`

const DotWrapper = styled.div`
  width: 25px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dfdede;
`

export const Dots = (dots) => <DotsList>{dots}</DotsList>

export const Dot = () => (
  <DotWrapper>
    <StyledDot className={dotClassName} />
  </DotWrapper>
)

/**
 * Stolen from
 * https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.css
 * and
 * https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.css
 *
 * Modified to function when serving locally, since the external styles want to
 * include external fonts.
 */
export const SlickStyles = styled.div`
  /* Slider */
  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;
    user-select: none;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
  }
  .slick-track:before,
  .slick-track:after {
    display: table;

    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  @charset 'UTF-8';
  /* Slider */
  .slick-loading .slick-list {
    background-color: #fff;
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    position: absolute;
    max-width: 70%;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
    bottom: -14px;
    @media ${mediaQueries.medium} {
      bottom: -19px;
    }

    background: transparent;

    display: block;

    padding: 0;

    list-style: none;

    text-align: center;
  }
  .slick-dots li {
    position: relative;

    display: inline-block;

    width: 25px;
    height: 20px;
    margin: 0;
    padding: 0;

    cursor: pointer;
  }

  /* Fix to prevent carousel from having an enormous width */
  .slick-list {
    overflow: hidden;
    min-width: 100%;
    width: 0;
  }

  .slick-dots .slick-active .${dotClassName} {
    background-color: #9a9999;
  }
`
